<div class="row">
  <div class="col">
    <h1>Comunicaciones</h1>
  </div>
</div>
<mat-tab-group [selectedIndex]="1">
  <mat-tab label="Mensajes">
    Mensajes
  </mat-tab>

  <mat-tab label="Feedbacks">
    <div class="d-flex justify-content-end align-items-center p-2">
      <div class="pr-4 py-1">
        Filtrar por fechas:
      </div>
      <div class="pr-4 py-1">
        <mat-form-field>
          <input matInput [matDatepicker]="fromDate" placeholder="Desde" [formControl]="fromDateControl">
          <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
          <mat-datepicker #fromDate></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="pr-4 py-1">
        <mat-form-field>
          <input matInput [matDatepicker]="toDate" placeholder="Hasta" [formControl]="toDateControl">
          <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
          <mat-datepicker #toDate></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="pr-4 py-1">
        <button mat-button color="primary" (click)="applyNewFilters()">Aplicar</button>
      </div>
    </div>

    <h3 class="font-weight-bold">Calificación general</h3>
    <div class="d-flex justify-content-between px-2 mb-5">
      <RatingSticker [ratings]="ratingList"> </RatingSticker>
    </div>

    <h3 class="font-weight-bold">Promedio de calificación por cancha</h3>
    <div class="fields__avg mb-5">
      <div class="field__avg" *ngFor="let fieldFeedback of fieldsFeedback">
        <div class="title">
          {{fieldFeedback.field}}
        </div>
        <div class="average">
          <span class="mr-2">{{fieldFeedback.avg_score ? fieldFeedback.avg_score.toFixed(1) : '-'}}</span>
          <i class="material-icons text-primary">{{fieldFeedback.avg_score ? 'star' : 'star_border'}}</i>
        </div>
      </div>
    </div>

    <h3 class="font-weight-bold">Feedbacks recibidos</h3>
    <div id="player__list">
      <table mat-table [dataSource]="feedbackList">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Nombre </th>
          <td mat-cell *matCellDef="let el"> {{el.user.name}} </td>
        </ng-container>
        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef> Telefono </th>
          <td mat-cell *matCellDef="let el"> {{el.user.phone}} </td>
        </ng-container>
        <ng-container matColumnDef="reservation">
          <th mat-header-cell *matHeaderCellDef> Turno </th>
          <td mat-cell *matCellDef="let el"> {{el.reservation}} </td>
        </ng-container>
        <ng-container matColumnDef="comment">
          <th mat-header-cell *matHeaderCellDef> Comentario </th>
          <td mat-cell *matCellDef="let el"> {{el.comment}} </td>
        </ng-container>
        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef> </th>
          <td width="5%" mat-cell *matCellDef="let el">
            <button mat-button mat-icon-button [matMenuTriggerFor]="feedbackOptions">
              <i class="material-icons">more_vert</i>
            </button>
            <mat-menu #feedbackOptions="matMenu" xPosition="before">
              <button (click)="viewFeedback($event, el.feedback, el.user.name)" mat-menu-item>Ver feedback</button>
            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let myRowData; columns: displayedColumns"></tr>
      </table>
      <mat-paginator [length]="resultsLength" [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-tab>
</mat-tab-group>